export enum UserSettingParameterValueTypeEnum {
	String = 'String',
	Boolean = 'Boolean',
	Integer = 'Integer',
	Double = 'Double',
	Json = 'Json',
}
